__turbopack_context__.v({
  "buttonContainer": "VwB01G_buttonContainer",
  "container": "VwB01G_container",
  "title": "VwB01G_title",
});
